/* eslint-disable */
import React from 'react'
import http from '../../Component/Interceptor/Interseptor'
import {Button, Container, Modal, ModalBody, ModalFooter, ModalHeader} from 'mdbreact'
import {accounting} from 'accounting'
import Page from '../Pagination/Pagination'
import HeaderTable from '../../Component/BaseComponent/HeaderTable'
import {Link} from 'react-router-dom'
import jMoment from 'moment-jalaali'
import $ from 'jquery'
import {message} from 'antd'
import REPORT_DISPATCH from '../BaseComponent/REPORTDISPATCH'
import USER_MANAGE from '../BaseComponent/USERMANAGE'
import RETAIL from '../BaseComponent/RETAIL'
import FromToPicker from '../BaseComponent/FromToPicker'
import ExcelExport from '@progress/kendo-react-excel-export/dist/npm/ExcelExport'
import HeaderTablePrint from '../BaseComponent/HeaderTablePrint'
import cookie from 'react-cookies'
import SearchableCombo from '../BaseComponent/searchableCombo'
import RemainDriverComponent from '../BaseComponent/remainDriverComponent'
import PrintRemainDriver from '../BaseComponent/printRemainDriver'
import Select from 'react-select'
import SearchProduct from '../BaseComponent/SearchProduct'
import REPORT_RETAIL from '../BaseComponent/REPORTRETAIL'
import Loader from '../loaders/loader'
import AutoComplete from '../BaseComponent/autocomplete'

class RemainReportDriver extends React.Component {
  convertDigit = (string) => {
    return string
      .replace(/[\u0660-\u0669]/g, function(c) {
        return c.charCodeAt(0) - 0x0660
      })
      .replace(/[\u06f0-\u06f9]/g, function(c) {
        return c.charCodeAt(0) - 0x06f0
      })
  }

  constructor(props) {
    super(props)
    this.state = {
      providerId: '',
      loading: false,
      baskets: [],
      lengthbaskets: 0,
      modal: false,
      urlSign: '',
      Drivers: [],
      tasvie: '',
      state: '',
      printInfo: [],
      fromDate: '',
      toDate: '',
      aggregation: {},
      buttonClicked: false,
      driverId: '',
      fromRegDate: '',
      toRegDate: '',
      selectedStockProductIds: [],
      arrayOfStocks: [],
      finalStocks: [],
      multiProduct: [],
      productArr: [],
      timesInterval: [],
      multiUnit: [],
      unitArr: [],
      providerArr: [],
      providers: []
    }
  }

  changeShift(e) {
    let target = e.target

    this.setState({
      shift: target.options[target.selectedIndex].text
    })
  }

  handleChangeUnit = (multiUnit) => {
    var unitArr = []
    this.setState({multiUnit})
    // alert(multiUnit.length)
    if (multiUnit.length == '0') {
      this.setState({
        unitArr: []
      })
    } else {
      for (let prop of multiUnit) {
        unitArr.push(prop.id)
        this.setState({
          unitArr: unitArr
        })
      }
    }
  }

  handleChangeProvider = (multiProvider) => {
    var providerArr = []
    this.setState({multiProvider})
    if (multiProvider.length == '0') {
      this.setState({
        providerArr: []
      })
    } else {
      for (let prop of multiProvider) {
        providerArr.push(prop.providerId)
        this.setState({
          providerArr: providerArr
        })
      }
    }
  }

  componentDidMount() {
    // http.get(`${REPORT_RETAIL.REPORT_RETAIL_LIST_PROVIDER}`,{

    // }).then((response)=>{
    //     if(response.data.error==null){

    //         var provider = response.data.object;
    //         for (let i = 0; i < provider.length; i++) {
    //             provider[i]['value'] = provider[i].providerId;
    //             provider[i]['label'] =provider[i].providerId +' - '+ provider[i].title;
    //         }

    //         this.setState({
    //             providers:response.data.object
    //         })
    //     }
    //     else{
    //         this.setState({
    //             providers:[]
    //         })
    //     }
    // })

    http.get(`public/base/type/timeIntervals`, {}).then((response) => {
      if (response.data.error == null) {
        this.setState({
          timesInterval: response.data.object
        })
      }
    })

    http.get(`${REPORT_RETAIL.REPORT_RETAIL_LIST_UNIT}`, {}).then((response) => {
      if (response.data.error == null) {
        var unit = response.data.object
        for (let i = 0; i < unit.length; i++) {
          unit[i]['value'] = unit[i].id
          unit[i]['label'] = unit[i].title
        }

        this.setState({
          unit: response.data.object
        })
      } else {
        this.setState({
          unit: []
        })
      }
    })

    http
      .get(`${USER_MANAGE.USER_MANAGE_LIST_DRIVER}`, {})
      .then((response) => {
        // alert(JSON.stringify(response.data))
        if (response.data.error == null) {
          var drivers = response.data.object
          for (let i = 0; i < drivers.length; i++) {
            drivers[i]['value'] = drivers[i].personId
            drivers[i]['label'] = drivers[i].personId + ' - ' + drivers[i].name
          }

          this.setState({
            Drivers: response.data.object
          })
        }
      })
      .catch((error) => {
        alert(JSON.stringify(error))
      })

    sessionStorage.removeItem('params')

    $(function() {
      $('.filterBtn').on('click', function() {
        $('.basketFilterComponent').slideToggle()
      })
    })
    sessionStorage.setItem('pageNumber', '1')
    sessionStorage.setItem('dropDownVal', '10')
  }

  onResultFetched(data) {
    this.setState({
      baskets: data
    })
  }

  changeDropDown(data) {
    this.setState({
      baskets: data,
      lengthProducts: sessionStorage.getItem('countAll')
    })
  }

  convertState = (x) => {
    if (x == -100) {
      x = 'کنسل'
      return x
    } else if (x == -75) {
      x = 'مرجوعی'
      return x
    } else if (x == -50) {
      x = 'بازگشتی'
      return x
    } else if (x == -25) {
      x = 'تخصیص مجدد'
      return x
    } else if (x == -1) {
      x = 'تخصیص داده نشده'
      return x
    } else if (x === 1) {
      x = 'فعال'
      return x
    } else if (x == 5) {
      x = 'اول فعال'
      return x
    } else if (x == 10) {
      x = 'شروع شده'
      return x
    } else if (x == 18) {
      x = 'تسویه نشده'
      return x
    } else if (x == 20) {
      x = 'تسویه شده'
      return x
    }
  }

  openSign = (num) => {
    sessionStorage.setItem('index', num)
    this.setState({
      modal: !this.state.modal
    })
    var deliveryPackId = this.state.baskets[num].deliveryPackId
    let data = {
      deliveryPackId: deliveryPackId
    }
    http
      .post(`${RETAIL.RETAIL_COMPANY_DELIVERYPACK_SIGN}`, data, {})
      .then((response) => {
        if (response.data.error == null) {
          this.setState({
            urlSign: `data:image/png;base64,${response.data.object}`
          })
        }
      })
      .catch((error) => {
        alert(JSON.stringify(error))
      })
  }
  toggle = () => {
    this.setState({
      modal: !this.state.modal
    })
  }

  handleCancel = (e) => {
    sessionStorage.removeItem('index')

    this.setState({
      modal: !this.state.modal
    })
  }

  getValueDriver = (driverId) => {
    this.setState({
      driverId
    })
  }

  changeField(e) {
    let target = e.target
    let value = target.value

    this.setState({
      tasvie: value == '' ? '' : Number(value)
    })
  }

  changeState(e) {
    let target = e.target
    let value = target.value

    this.setState({
      state: value
    })
  }

  convertDigit = (string) => {
    return string
      .replace(/[\u0660-\u0669]/g, function(c) {
        return c.charCodeAt(0) - 0x0660
      })
      .replace(/[\u06f0-\u06f9]/g, function(c) {
        return c.charCodeAt(0) - 0x06f0
      })
  }

  handleChangeFromDate = (fromDate) => {
    this.setState({
      fromDate
    })
  }

  handleChangeToDate = (toDate) => {
    this.setState({
      toDate
    })
  }

  handleChangeFromRegDate = (fromRegDate) => {
    this.setState({
      fromRegDate
    })
  }

  handleChangeToRegDate = (toRegDate) => {
    this.setState({
      toRegDate
    })
  }

  getStocks = (arrayOfStocks) => {
    var stockArr = []

    this.setState({
      arrayOfStocks
    })

    if (arrayOfStocks.length == '0') {
      this.setState({
        finalStocks: []
      })
    } else {
      for (let prop of arrayOfStocks) {
        stockArr.push(prop.value)
        this.setState({
          finalStocks: stockArr
        })
      }
    }
  }

  finalStocks = (finalStocks) => {
    let array = []
    finalStocks.forEach((item) => {
      array.push(item.stockProductId)
    })
    this.setState({
      finalStocks: array
    })
  }

  getValueDriver = (driverId) => {
    this.setState({
      driverId
    })
  }

  filter() {
    sessionStorage.setItem('pageNumber', '1')
    sessionStorage.setItem('dropDownVal', '10')
    let {providerArr, unitArr, finalStocks, providerId} = this.state

    let minDate = this.state.fromDate
    let maxDate = this.state.toDate
    let fromRegDate = this.state.fromRegDate
    let toRegDate = this.state.toRegDate
    let planTimeType = document.getElementById('planTimeType').value
    let invoiceNum = this.convertDigit(document.getElementById('invoiceNum').value.trim())
    let invoiceId = this.convertDigit(document.getElementById('invoiceId').value.trim())
    let buyerName = document.getElementById('buyerName').value
    let userCode = document.getElementById('userCode').value.trim()
    let nationalId = document.getElementById('nationalId').value.trim()
    let mobile = document.getElementById('mobile').value.trim()
    let recipientName = document.getElementById('recipientName').value.trim()
    let paid = document.getElementById('paid').value
    let confirmed = document.getElementById('confirmed').value
    let canceled = document.getElementById('canceled').value
    let payOnDelivery = document.getElementById('payOnDelivery').value
    let driverId = this.state.driverId == null || this.state.driverId == '' ? '' : this.state.driverId.personId
    let payableAmountMin = this.convertDigit(document.getElementById('payableAmountMin').value.trim())
    let payableAmountMax = this.convertDigit(document.getElementById('payableAmountMax').value.trim())
    let lastState = document.getElementById('lastState').value
    if (
      canceled === '' &&
      confirmed === '' &&
      nationalId === '' &&
      fromRegDate === '' &&
      toRegDate === '' &&
      mobile === '' &&
      finalStocks.length === 0 &&
      planTimeType == '' &&
      userCode == '' &&
      driverId == '' &&
      payableAmountMax == '' &&
      payableAmountMin == '' &&
      lastState == '' &&
      minDate == '' &&
      maxDate == '' &&
      invoiceNum == '' &&
      invoiceId == '' &&
      buyerName == '' &&
      recipientName == '' &&
      paid == '' &&
      payOnDelivery == ''
    ) {
      message.error('حداقل یک فیلتر وارد شود')
    }
    if (minDate === '' || maxDate === '') {
      message.error('هر دو تاریخ تحویل وارد شود')
    } else if ((minDate != '' || minDate == null) && isNaN(minDate)) {
      message.error('فرمت تاریخ تحویل ابتدا صحیح نیست')
    } else if ((maxDate != '' || maxDate == null) && isNaN(maxDate)) {
      message.error('فرمت تاریخ تحویل انتها صحیح نیست')
    } else if ((fromRegDate != '' || fromRegDate == null) && isNaN(fromRegDate)) {
      message.error('فرمت تاریخ ثبت ابتدا صحیح نیست')
    } else if ((toRegDate != '' || toRegDate == null) && isNaN(toRegDate)) {
      message.error('فرمت تاریخ ثبت انتها صحیح نیست')
    } else if (mobile != '' && !mobile.match(/^09\d{9}$/g)) {
      message.error('موبایل را صحیح وارد کنید')
    } else {
      this.setState({
        toPrintDate: minDate == '' ? '-' : jMoment(this.state.fromDate).format('jYY/jMM/jDD'),
        fromPrintDate: maxDate == '' ? '-' : jMoment(this.state.toDate).format('jYY/jMM/jDD'),
        loading: true
      })

      sessionStorage.setItem(
        'params',
        `canceled=${canceled}&confirmed=${confirmed}&registerDateMin=${
          fromRegDate == '' ? '' : fromRegDate
        }&registerDateMax=${
          toRegDate == '' ? '' : toRegDate
        }&userNationalId=${nationalId}&userCode=${userCode}&mobile=${mobile}&timeIntervalId=${planTimeType}&planDateMin=${
          minDate == '' ? '' : minDate
        }&planDateMax=${
          maxDate == '' ? '' : maxDate
        }&invoiceNum=${invoiceNum}&invoiceId=${invoiceId}&buyerName=${buyerName}&recipientName=${recipientName}&paid=${paid}&payOnDelivery=${payOnDelivery}&driverId=${driverId}&payableAmountMin=${payableAmountMin}&payableAmountMax=${payableAmountMax}&lastState=${lastState}&providerIds=${providerId}&productUnitIds=${unitArr}&stockProductIds=${finalStocks}&sortBy=planDate_Desc,planTimeFrom_Asc,invoiceNum_Asc`
      )
      http
        .get(
          `${
            REPORT_DISPATCH.REPORT_DISPATCH_REMAIN_AMOUNT
          }?export=false&pageSize=10&pageNumber=1&${sessionStorage.getItem('params')}`,
          {}
        )
        .then((response) => {
          if (response.data.error == null) {
            console.log(response.data)
            $('.showBaseTable,.print').fadeIn()

            sessionStorage.setItem('countAll', response.data.object.countAll)
            this.setState({
              baskets: response.data.object.result,
              lengthbaskets: response.data.object.countAll,
              aggregation: response.data.object.aggregation,
              buttonClicked: true,
              loading: false
            })
          } else {
            $('.showBaseTable,.print').fadeOut()
            this.setState({
              loading: false
            })
            // message.error('خطای ' + response.data.errorCode + ' : ' + response.data.description)
          }
        })
        .catch((error) => {
          alert(JSON.stringify(error))
        })
    }
  }

  getPrintInfo = () => {
    this.setState({
      loading: true
    })

    http
      .get(`${REPORT_DISPATCH.REPORT_DISPATCH_REMAIN_AMOUNT}?export=true&${sessionStorage.getItem('params')}`, {})
      .then((response) => {
        if (response.data.error == null) {
          this.setState({
            printInfo: response.data.object.result,
            aggregation: response.data.object.aggregation,
            loading: false
          })
          setTimeout(() => {
            window.print()
          }, 2000)
        }
      })
      .catch((error) => {
        alert(JSON.stringify(error))
      })
  }

  exportPrint = () => {
    var css = '@page { size:A4 landscape;}',
      head = document.head || document.getElementsByTagName('head')[0],
      style = document.createElement('style')

    style.type = 'text/css'
    style.media = 'print'

    if (style.styleSheet) {
      style.styleSheet.cssText = css
    } else {
      style.appendChild(document.createTextNode(css))
    }

    head.appendChild(style)
    this.getPrintInfo()
  }

  exportExcel = () => {
    http
      .get(
        `${REPORT_DISPATCH.REPORT_DISPATCH_REMAIN_AMOUNT}?export=true&pageSize=10&pageNumber=1&${sessionStorage.getItem(
          'params'
        )}`,
        {}
      )
      .then((response) => {
        if (response.data.error == null) {
          this.setState({
            excelReport: response.data.object.result
          })
          let {excelReport} = this.state
          for (let i = 0; i < excelReport.length; i++) {
            excelReport[i]['planDate'] = jMoment(excelReport[i]['planDate']).format('jYY/jMM/jDD')
            excelReport[i]['dispatchDate'] = jMoment(excelReport[i]['dispatchDate']).format('jYY/jMM/jDD HH:mm')

            excelReport[i]['bazeTahvil'] =
              excelReport[i]['planTimeFrom'].substr(0, 5) + ' - ' + excelReport[i]['planTimeTo'].substr(0, 5)

            if (excelReport[i]['driver'] == null) {
              excelReport[i]['driver'] = '-'
            } else {
              excelReport[i]['driver'] = excelReport[i].driver['name']
            }

            if (excelReport[i]['lastState'] == '20') {
              excelReport[i]['kalayetahvil'] = excelReport[i].totalInfo['totalCount']
            } else {
              excelReport[i]['kalayetahvil'] = '0'
            }

            if (excelReport[i].invoice['paid']) {
              excelReport[i]['pretasvieh'] = excelReport[i].totalInfo['payableAmount']
            } else {
              excelReport[i]['pretasvieh'] = '0'
            }

            if (excelReport[i].invoice['deliveredBetween']) {
              excelReport[i]['deliveredBetween'] = 'در بازه'
            } else {
              excelReport[i]['deliveredBetween'] = 'خارج از بازه'
            }
            excelReport[i]['mande'] =
              excelReport[i].totalInfo['payableAmount'] -
              excelReport[i]['pretasvieh'] +
              excelReport[i].payment['cash'] +
              excelReport[i].payment['card'] +
              excelReport[i].payment['prePaid']
          }

          this._export.save(this.state.excelReport)
        } else {
          this.setState({
            excelReport: []
          })
        }
      })
      .catch((error) => {
        // alert(JSON.stringify(error))
      })

    // this._export.save(excelData)
  }

  render() {
    const {lengthbaskets, loading} = this.state
    var params = sessionStorage.getItem('params')

    let excelColumns = [
      {title: 'نام خریدار', value: 'buyerName'},
      {title: 'نام تحویل گیرنده', value: 'recipientName'},
      {title: 'ادرس', value: 'address'},
      {title: 'موبایل', value: 'mobile'},
      {title: 'تلفن', value: 'phone'},
      {title: 'شیوه ارسال', value: 'deliveryMethodTitle'}
    ]

    return (
      <div className="rtl printA4Page">
        <Loader show={loading} />

        <PrintRemainDriver
          printInfo={this.state.printInfo}
          rightSectionPrint={'تاریخ از : ' + this.state.toPrintDate + ' تا ' + this.state.fromPrintDate}
          centerSectionPrint={''}
          columns={[]}
          aggregation={this.state.aggregation}
        />

        <div className="excelSection">
          <ExcelExport
            dir="rtl"
            ref={(exporter) => {
              this._export = exporter
            }}
            fileName="گزارش مانده رساننده.xls"
          >
            <grid style={{height: '420px'}} data={this.state.excelReport}>
              <gridColumn
                key={'planDate'}
                field={'planDate'}
                title={'تاریخ تحویل'}
                width="100px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />

              <gridColumn
                key={'dispatchDate'}
                field={'dispatchDate'}
                title={'زمان تحویل'}
                width="100px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />

              <gridColumn
                key={'bazeTahvil'}
                field={'bazeTahvil'}
                title={'بازه تحویل'}
                width="100px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />

              <gridColumn
                key={'invoiceId'}
                field={'invoice.invoiceId'}
                title={'شناسه فاکتور'}
                width="100px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />

              <gridColumn
                key={'invoiceNum'}
                field={'invoice.invoiceNum'}
                title={'شماره فاکتور'}
                width="100px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />

              <gridColumn
                key={'userCode'}
                field={'customer.userCode'}
                title={'کد مشتری'}
                width="100px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />

              <gridColumn
                key={'nationalId'}
                field={'customer.nationalId'}
                title={'کد ملی'}
                width="100px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />

              <gridColumn
                key={'driver'}
                field={'driver'}
                title={'رساننده'}
                width="100px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />

              <gridColumn
                key={'totalCount'}
                field={'totalInfo.totalCount'}
                title={'تعداد کالای پارت تحویل'}
                width="100px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />

              <gridColumn
                key={'kalayetahvil'}
                field={'kalayetahvil'}
                title={'تعداد کالای تحویل شده'}
                width="100px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />

              <gridColumn
                key={'deliveredBetween'}
                field={'deliveredBetween'}
                title={'تحویل'}
                width="100px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />

              <gridColumn
                key={'payableAmount'}
                field={'totalInfo.payableAmount'}
                title={'بدهکار'}
                width="100px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />

              <gridColumn
                key={'pretasvieh'}
                field={'pretasvieh'}
                title={'تسویه از قبل'}
                width="100px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />

              <gridColumn
                key={'cash'}
                field={'payment.cash'}
                title={'نقدی'}
                width="100px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />
              <gridColumn
                key={'card'}
                field={'payment.card'}
                title={'کارتخوان'}
                width="100px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />

              <gridColumn
                key={'prePaid'}
                field={'payment.prePaid'}
                title={'پرداخت از قبل'}
                width="100px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />

              <gridColumn
                key={'mande'}
                field={'mande'}
                title={'مانده'}
                width="100px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />
            </grid>
          </ExcelExport>
        </div>

        <div className="wrapperIframe">
          <ul className="breadcrumb">
            <li>
              <Link to={'/search'}>به روزرسان</Link>
            </li>
            <li>گزارشات</li>
            <li>مانده رساننده</li>
          </ul>
          <div className="tableComponent">
            <div className="tableTools">
              <div className="tableOptionWrapp">
                <HeaderTable
                  addUrl=""
                  url={REPORT_DISPATCH.REPORT_DISPATCH_REMAIN_AMOUNT}
                  ChangeDropDown={this.changeDropDown.bind(this)}
                  printUrl=""
                  showRow={false}
                  printLink=""
                  printComponent={this.printTable}
                  execelUrl={REPORT_DISPATCH.REPORT_DISPATCH_REMAIN_AMOUNT + '?export=true'}
                  excelColumns={excelColumns}
                  titleAdd=""
                />

                <button className="filterBtn">
                  <i className="fa fa-search" />
                </button>
                <button
                  className={'printButton'}
                  disabled={this.state.buttonClicked ? false : true}
                  onClick={this.exportExcel}
                >
                  <i className="fas fa-file-excel" />
                </button>
                <button
                  className="printButton"
                  disabled={this.state.buttonClicked ? false : true}
                  onClick={this.exportPrint}
                >
                  <i className="fas fa-print" />
                </button>
              </div>
            </div>
            <div className="basketFilterComponent">
              <div className="filterInputs">
                <FromToPicker
                  onChangeFromDate={this.handleChangeFromDate}
                  onChangeToDate={this.handleChangeToDate}
                  fromLabel="تاریخ تحویل از"
                  toLabel="تاریخ تحویل تا"
                  defaulValue={true}
                  // defaulValue={this.state.defaultValueDate}
                  fromId="from"
                  toId="to"
                />

                <FromToPicker
                  onChangeFromDate={this.handleChangeFromRegDate}
                  onChangeToDate={this.handleChangeToRegDate}
                  fromLabel="تاریخ ثبت از"
                  toLabel="تاریخ ثبت تا"
                  fromId="fromReg"
                  toId="toReg"
                />

                <div className="formComponent">
                  <label>شیفت زمانی :</label>
                  <select className="form-control" onChange={this.changeShift.bind(this)} id="planTimeType">
                    <option value="">-------</option>
                    {this.state.timesInterval.map((shift, index) => (
                      <option value={shift.timeIntervalId}>{shift.timeStart + ' تا ' + shift.timeEnd}</option>
                    ))}
                  </select>
                </div>

                <div className="formComponent">
                  <label>شناسه فاکتور:</label>
                  <input
                    type="text"
                    defaultValue={this.state.invoiceId}
                    className="form-control"
                    id="invoiceId"
                    name="invoiceId"
                  />
                </div>

                <div className="formComponent">
                  <label>شماره فاکتور:</label>
                  <input type="text" className="form-control" id="invoiceNum" name="invoiceNum" />
                </div>

                <div className="formComponent">
                  <label>کد مشتری:</label>
                  <input
                    type="text"
                    defaultValue={this.state.userCode}
                    className="form-control"
                    id="userCode"
                    name="userCode"
                  />
                </div>

                <div className="formComponent">
                  <label>کد ملی مشتری:</label>
                  <input type="text" className="form-control" id="nationalId" name="nationalId" />
                </div>

                <div className="formComponent">
                  <label>موبایل (در فاکتور) : </label>
                  <input type="text" className="form-control" id="mobile" name="mobile" />
                </div>

                <div className="formComponent">
                  <label>نام خریدار (در فاکتور) :</label>
                  <input type="text" className="form-control" id="buyerName" name="buyerName" />
                </div>

                <div className="formComponent">
                  <label>نام تحویل گیرنده (در فاکتور) :</label>
                  <input type="text" className="form-control" id="recipientName" name="recipientName" />
                </div>

                <div className="formComponent">
                  <label>وضعیت تایید :</label>
                  <select className="form-control" id="confirmed" name="confirmed">
                    <option value="">-------</option>
                    <option selected={true} value={1}>
                      تایید شده
                    </option>
                    <option value={0}>تایید نشده</option>
                  </select>
                </div>

                <div className="formComponent">
                  <label>وضعیت کنسل :</label>
                  <select className="form-control" id="canceled" name="canceled">
                    <option value="">-------</option>
                    <option value={1}>کنسل شده</option>
                    <option selected={true} value={0}>
                      کنسل نشده
                    </option>
                  </select>
                </div>

                <div className="formComponent">
                  <label>وضعیت پرداخت :</label>
                  <select className="form-control" id="paid" name="paid">
                    <option value="">-------</option>
                    <option value={1}>پرداخت شده</option>
                    <option value={0}>پرداخت نشده</option>
                  </select>
                </div>

                <div className="formComponent">
                  <label>پرداخت در محل :</label>
                  <select className="form-control" id="payOnDelivery" name="payOnDelivery">
                    <option value="">-------</option>
                    <option value={1}>بله</option>
                    <option value={0}>خیر</option>
                  </select>
                </div>

                <div className="formComponent">
                  <label>حالت:</label>
                  <select
                    className="form-control"
                    onChange={this.changeState.bind(this)}
                    id="lastState"
                    name="lastState"
                  >
                    <option value="">-------</option>
                    <option value="-100">کنسل</option>
                    <option value="-75">مرجوعی</option>
                    <option value="-50">بازگشتی</option>
                    <option value="100">تخصیص مجدد</option>
                    <option value="-1">تخصیص داده نشده</option>
                    <option value="1">فعال</option>
                    <option value="5">اول فعال</option>
                    <option value="10">شروع شده</option>
                    <option value="18">تسویه شده</option>
                  </select>
                </div>

                <div className="formComponent">
                  <SearchableCombo
                    options={this.state.Drivers}
                    getValueCombo={this.getValueDriver}
                    lableText="رساننده"
                    placeholder="------"
                    isClearable={true}
                    isMulti={false}
                    isDisabled={false}
                  />
                </div>

                <div className="formComponent">
                  <label>قابل پرداخت از :</label>
                  <input type="text" className="form-control" id="payableAmountMin" name="payableAmountMin" />
                </div>

                <div className="formComponent">
                  <label>قابل پرداخت تا :</label>
                  <input type="text" className="form-control" id="payableAmountMax" name="payableAmountMax" />
                </div>

                <div className="formComponent">
                  <label>واحد کالا :</label>
                  <Select
                    value={this.state.multiUnit}
                    onChange={this.handleChangeUnit}
                    options={this.state.unit}
                    isMulti={true}
                    isClearable={true}
                    placeholder=""
                  />
                </div>

                <div className="formComponent selectComponent">
                  <AutoComplete
                    label="تامین کننده"
                    api={`${REPORT_RETAIL.REPORT_RETAIL_LIST_PROVIDER}`}
                    textField="title"
                    valueField="providerId"
                    id="provider"
                    value={this.state.providerId}
                    setValue={(providerId) => this.setState({providerId})}
                  />
                  {/* <label>تامین کننده ها :</label>
                                    <Select
                                        value={this.state.multiProvider}
                                        onChange={this.handleChangeProvider}
                                        options={this.state.providers}
                                        isMulti={true}
                                        isClearable={true}
                                        placeholder=''
                                    /> */}
                </div>
              </div>
              <div>
                {this.state.providers.length ? (
                  <SearchProduct
                    getStocks={this.getStocks}
                    finalStocks={this.finalStocks}
                    providers={this.state.providers}
                  />
                ) : null}
              </div>
              <div className="filterOption">
                <button className="confirmFilter" onClick={this.filter.bind(this)}>
                  جست و جو
                </button>
              </div>
            </div>

            <RemainDriverComponent remainInfo={this.state.baskets} aggregation={this.state.aggregation} />
            <div className="paginationWrapp showBaseTable print">
              <Page
                defaultCurrent={1}
                total={lengthbaskets}
                onResultFetched={this.onResultFetched.bind(this)}
                url={REPORT_DISPATCH.REPORT_DISPATCH_REMAIN_AMOUNT}
                urlParams={params + '&sortBy=dispatchDate_Desc'}
              />
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default RemainReportDriver
